/**
 * QueryClient 정본 — 프로바이더·훅·테스트가 같은 인스턴스를 쓴다.
 */
import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient 설정
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 기본 옵션
      staleTime: 1000, // 1초 후 stale
      gcTime: 5 * 60 * 1000, // 5분간 캐시 유지 (이전 cacheTime)
      retry: 3, // 3회 재시도
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false, // 윈도우 포커스 시 리페치 비활성화
      refetchOnReconnect: true, // 재연결 시 리페치
    },
    mutations: {
      retry: 1, // 뮤테이션은 1회만 재시도
      retryDelay: 1000,
    },
  },
});
